import http from '@/api/http'

export default {
    applyForAuthCode(cb) {
        http.get('/api/oauth2/apply/auth-code', cb);
    },
    applyForToken(cb, code) {
        http.get('/api/oauth2/sso/code/portal', cb, { 'code': code })
    },
    oauth2Login(cb) {
        http.get('/api/oauth2/getLoginUrl', cb);
    }
}